<template>
  <div id="info-chart">
    <p class="mb-5" v-if="rcoData">
      {{ rcoData.Long }}
    </p>
    <h3 class="mb-4" v-if="rcoData">{{ rcoData.Short.toUpperCase() }}</h3>
    <div class="chart-container position-relative">
      <div class="chart-labels">
        <div class="row mx-4">
          <div class="col-4">
            <div class="center d-flex align-items-end">
              <span>Newbuilding</span>
              <span>Existing<br />Ship</span>
            </div>
          </div>
          <div class="col-4">
            <div class="center d-flex align-items-end">
              <span>Newbuilding</span>
              <span>Existing<br />Ship</span>
            </div>
          </div>
          <div class="col-4">
            <div class="center d-flex align-items-end">
              <span>Newbuilding</span>
              <span>Existing<br />Ship</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row mx-4">
        <div class="category col-4">
          <Chart
            v-if="rcoData"
            :series="setSeries('Ferry')"
            :category="['Ferry Ropax']"
            :chartColors="setColors('Ferry')"
          ></Chart>
        </div>
        <div class="category col-4">
          <Chart
            v-if="rcoData"
            :series="setSeries('Standard')"
            :category="['Standard Ropax']"
            :chartColors="setColors('Standard')"
          ></Chart>
        </div>
        <div class="category col-4">
          <Chart
            v-if="rcoData"
            :series="setSeries('Cargo')"
            :category="['Cargo Ropax']"
            :chartColors="setColors('Cargo')"
          ></Chart>
        </div>
      </div>
      <div class="chart-icons">
        <div class="row mx-4">
          <div
            class="col-4 d-flex justify-content-center transition scale-effect"
          >
            <div class="icon">
              <router-link to="/ship-info">
                <img src="../../public/assets/img/icon_ferry.png" />
                <span>Ferry Ropax</span>
              </router-link>
            </div>
          </div>
          <div
            class="col-4 d-flex justify-content-center transition scale-effect"
          >
            <div class="icon">
              <router-link to="/ship-info">
                <img src="../../public/assets/img/icon_standard.png" />
                <span>Standard Ropax</span>
              </router-link>
            </div>
          </div>
          <div
            class="col-4 d-flex justify-content-center transition scale-effect"
          >
            <div class="icon">
              <router-link to="/ship-info">
                <img src="../../public/assets/img/icon_cargo.png" />
                <span>Cargo Ropax</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-5" id="legend">
      <div class="ships-legend col">
        <div class="row">
          <div class="legend-item col px-0 mr-3 transition scale-effect">
            <router-link to="/info-ships">
              <img src="../../public/assets/img/icon_ferry.png" />
              <span>Ferry Ropax</span>
            </router-link>
          </div>
          <div class="legend-item col px-0 mr-3 transition scale-effect">
            <router-link to="/info-ships">
              <img src="../../public/assets/img/icon_standard.png" />
              <span>Standard Ropax</span>
            </router-link>
          </div>
          <div class="legend-item col px-0 transition scale-effect">
            <router-link to="/info-ships">
              <img src="../../public/assets/img/icon_cargo.png" />
              <span>Cargo Ropax</span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="risk-reduction col">
        <v-popover
          offset="16"
          :trigger="'click hover'"
          :placement="'bottom'"
          style="display: block !important;
    margin: 0 auto;
    width: fit-content;"
        >
          <button class="btn btn-default">% RISK REDUCTION</button>
          <img src="../../public/assets/img/icon_info_normal.png" />
          <template slot="popover">
            <InfoTooltip :msg="msg"></InfoTooltip>
          </template>
        </v-popover>
      </div>
      <div class="costs-legend col">
        <div class="row">
          <div class="legend-item col px-0 mr-3">
            <div class="costs-green"></div>
            <span>Cost effective solution</span>
          </div>
          <div class="legend-item col px-0 mr-3">
            <div class="costs-yellow"></div>
            <span>Solution slightly above the threshold</span>
          </div>
          <div class="legend-item col px-0">
            <div class="costs-red"></div>
            <span>Extremely costly solution</span>
          </div>
        </div>
      </div>
    </div>
    <p class="text-center" v-if="rcoData">Reference: {{ rcoData.Reference }}</p>
  </div>
</template>

<script>
import Chart from "./Chart";
import InfoTooltip from "./InfoTooltip";
import emsaJson from "../../data.json";

export default {
  name: "InfoChart",
  components: {
    Chart,
    InfoTooltip
  },
  data: function() {
    return {
      data: emsaJson,
      msg: {
        message: "NOTE",
        list: [
          "Relative risk reduction in terms of potential loss of life (PLL)",
          "Colour code based on Gross Cost of Averting a Fatality (GCAF) with a threshold of €7m. Green indicates cost effective solutions, orange indicates solutions slightly above the threshold (GCAF factor up to 3) and red indicates solutions that were found to be extremely costly in relation to their risk reduction (GCAF factor above 3)."
        ]
      }
    };
  },
  computed: {
    rcoData() {
      let selectedRCOData = this.data[this.getType].Data;
      let selectedRCO = this.$store.state.firesafe.selectedRCO;
      let result = this.filterByValue(selectedRCOData, selectedRCO);
      return result[0];
    },
    getType() {
      return this.$route.params.type.toUpperCase();
    },
    series() {
      return [
        {
          name: "Newbuilding",
          data: [parseInt(this.rcoData.Ferry.NB.Value)]
        },
        {
          name: "Existing Ship",
          data: [parseInt(this.rcoData.Ferry.Existing.Value)]
        }
      ];
    }
  },
  methods: {
    filterByValue(array, number) {
      return array.filter(function(rco) {
        return rco.Number === number;
      });
    },
    setSeries(type) {
      return [
        {
          name: "Newbuilding",
          data: [parseInt(this.rcoData[type].NB.Value)]
        },
        {
          name: "Existing Ship",
          data: [parseInt(this.rcoData[type].Existing.Value)]
        }
      ];
    },
    setColors(type) {
      return [this.rcoData[type].NB.Color, this.rcoData[type].Existing.Color];
    }
  }
};
</script>

<style scoped></style>
